
import React, { useState, useEffect } from 'react';

const SalaryRangeFilter = ({ minSalary, maxSalary, selectedRange, onChange }) => {
    const [localMin, setLocalMin] = useState(selectedRange.min);
    const [localMax, setLocalMax] = useState(selectedRange.max);
  
    useEffect(() => {
      setLocalMin(selectedRange.min);
      setLocalMax(selectedRange.max);
    }, [selectedRange.min, selectedRange.max]);
  
    const formatSalary = (amount) => {
      if (amount >= 100000) {
        return `₹${(amount / 100000).toFixed(1)}L`;
      } else if (amount >= 1000) {
        return `₹${(amount / 1000).toFixed(0)}K`;
      }
      return `₹${amount}`;
    };
  
    if (!minSalary || !maxSalary || minSalary === Infinity || maxSalary === -Infinity) {
      return <div className="text-sm text-gray-500">No salary data available</div>;
    }
  
    return (
      <div className="space-y-3">
        <div className="text-sm text-gray-700 font-medium text-center">
          {formatSalary(localMin)} - {formatSalary(localMax)}
        </div>
        
        <div className="space-y-2">
          <div>
            <label className="block text-xs text-gray-500 mb-1">Min: {formatSalary(localMin)}</label>
            <input
              type="range"
              min={minSalary}
              max={maxSalary}
              value={localMin}
              onChange={(e) => {
                const value = parseInt(e.target.value);
                setLocalMin(value);
                onChange({ min: value, max: localMax });
              }}
              className="w-full h-1.5 bg-gray-200 rounded-lg appearance-none cursor-pointer"
            />
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Max: {formatSalary(localMax)}</label>
            <input
              type="range"
              min={minSalary}
              max={maxSalary}
              value={localMax}
              onChange={(e) => {
                const value = parseInt(e.target.value);
                setLocalMax(value);
                onChange({ min: localMin, max: value });
              }}
              className="w-full h-1.5 bg-gray-200 rounded-lg appearance-none cursor-pointer"
            />
          </div>
        </div>
  
        <div className="flex flex-wrap gap-1">
          <button
            onClick={() => {
              setLocalMin(minSalary);
              setLocalMax(400000);
              onChange({ min: minSalary, max: 400000 });
            }}
            className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition-colors"
          >
            Under 4L
          </button>
          <button
            onClick={() => {
              setLocalMin(400000);
              setLocalMax(500000);
              onChange({ min: 400000, max: 500000 });
            }}
            className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition-colors"
          >
            4L-5L
          </button>
          <button
            onClick={() => {
              setLocalMin(500000);
              setLocalMax(maxSalary);
              onChange({ min: 500000, max: maxSalary });
            }}
            className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition-colors"
          >
            5L+
          </button>
        </div>
        <div className="flex items-center space-x-2 w-full">
          <input 
            value={localMin} 
            onChange={(e) => {
              setLocalMin(parseInt(e.target.value));
              onChange({ min: parseInt(e.target.value), max: localMax });
            }} 
            type="number" 
            placeholder="Min"  
            className="w-1/2 border border-gray-300 rounded px-2 py-1 text-xs"
          />
          <input 
            value={localMax} 
            onChange={(e) => {
              setLocalMax(parseInt(e.target.value));
              onChange({ min: localMin, max: parseInt(e.target.value) });
            }} 
            type="number" 
            placeholder="Max" 
            className="w-1/2 border border-gray-300 rounded px-2 py-1 text-xs"
          />
        </div>
      </div>
    );
  };

  export default SalaryRangeFilter;